// extracted by mini-css-extract-plugin
export default {"loader-container":"Loading_loader-container__r0tSj","spin-anim":"Loading_spin-anim__EmlpP"};